import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Icon from './Icon';
import { apiRequest, formatDate } from '../../utils';

import './MetPeopleList.css';

/* "People you met" — everyone this person swapped details with by QR, over every event, newest
   first and grouped by where it happened. Backend: GET /api/meet/mine.

   ★ It spans ALL events on purpose. The QR sheet already answers "who did I meet here"; what a
   list is for is the one the mail cannot be: an address book that survives the inbox.

   ★ A component rather than a page, because it renders in two places: the "Met at events" tab on
   My Network — the entry point people actually reach — and the /my-connections route it was born
   as, which stays valid so a link that was handed out keeps working. */
const MetPeopleList = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [status, setStatus] = useState('loading'); // loading | ready | error

  useEffect(() => {
    let cancelled = false;
    apiRequest('GET', '/meet/mine')
      .then((res) => {
        if (cancelled) return;
        setData(res);
        setStatus('ready');
      })
      .catch(() => { if (!cancelled) setStatus('error'); });
    return () => { cancelled = true; };
  }, []);

  return (
    <>
      {status === 'loading' && <div className="met__empty">{t('loading')}</div>}
      {status === 'error' && <div className="met__empty">{t('somethingWentWrong')}</div>}

      {status === 'ready' && (!data || !data.total) && (
        <div className="met__empty">{t('meetPeopleEmpty')}</div>
      )}

      {status === 'ready' && data && data.total > 0 && data.events.map((group) => (
        <div className="met__group" key={group.event_id}>
          <div className="met__group-head">
            {group.event_name || t('anEvent')}
            {group.event_date && (
              <span className="met__group-date">{formatDate(group.event_date)}</span>
            )}
          </div>
          {group.people.map((p) => (
            <Link className="met__row" to={`/u/${p.id}`} key={`${group.event_id}-${p.id}`}>
              {p.photo_url
                ? <img className="met__avatar" src={p.photo_url} alt="" />
                : <div className="met__avatar met__avatar--blank">
                    {(p.full_name || '?').slice(0, 1).toUpperCase()}
                  </div>}
              <div className="met__body">
                <div className="met__name">{p.full_name || p.email}</div>
                <div className="met__meta">
                  {[p.company_name, p.email].filter(Boolean).join(' · ')}
                </div>
              </div>
              <Icon name="angle-right" theme="light" />
            </Link>
          ))}
        </div>
      ))}
    </>
  );
};

export default MetPeopleList;
